import { Dispatch, FC, SetStateAction, useEffect } from 'react';

import leapifyLogo from 'assets/images/Leapify-Logo.svg';
import { type FormikHelpers } from 'formik';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Button } from 'ui/components/common';
import { cn } from 'utils/helpers';

import ForgotPasswordForm from '../../../public/forms/ForgotPasswordForm';
import {
  FORGOT_PASSWORD_FORM,
  FORGOT_PASSWORD_SCHEMA,
} from '../../../public/forms/schema';
import { useForgotPassword } from '../../../public/hooks';

interface PROPS {
  setRequested: Dispatch<SetStateAction<boolean>>;
  setEmailAddress: Dispatch<SetStateAction<null | string>>;
}

const FORM_INIT = {
  emailAddress: '',
};

const Form: FC<PROPS> = ({ setRequested, setEmailAddress }) => {
  const navigate = useNavigate();
  const { data: res, isLoading, mutate: forgotPassword } = useForgotPassword();

  const onSubmit = (
    values: FORGOT_PASSWORD_FORM,
    { setSubmitting }: FormikHelpers<FORGOT_PASSWORD_FORM>,
  ) => {
    forgotPassword(values);
    setEmailAddress(values.emailAddress);
    setSubmitting(false);
  };

  useEffect(() => {
    if (res) setRequested(true);
  }, [setRequested, res]);

  return (
    <div
      data-aos="fade-up"
      className={cn(
        'rounded-[6px] bg-fill-tertiary shadow-leapify-sm',
        'px-[31px] py-[56px]',
        'md:w-[600px] text-center',
      )}
    >
      <img
        alt="Leapify Logo"
        className="w-[170px] mb-[55px] inline-block mx-auto"
        src={leapifyLogo}
      />
      <div className="max-w-[428px] mx-auto">
        <h3 className={cn('mb-[16px]', 'text-center', 'text-xl font-semibold')}>
          Reset your password
        </h3>
        <p className="text-sm mb-[44px]">
          Please enter the email address you’d like your password reset
          infomation sent to.
        </p>
        <Formik
          initialValues={FORM_INIT}
          onSubmit={onSubmit}
          validationSchema={FORGOT_PASSWORD_SCHEMA}
        >
          <ForgotPasswordForm disabled={isLoading} />
        </Formik>
        <Button
          label="GO BACK TO LOGIN"
          type="button"
          className="w-full font-semibold mb-[15px]"
          intent="tertiary"
          size="lg"
          onClick={() => navigate('/')}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default Form;
